import { UserRole } from '../types/user';
/**
 * Check if a user role has permission for a given action
 */
export function hasPermission(userRole, requiredRole) {
    const roleHierarchy = {
        [UserRole.ANONYMOUS]: 0,
        [UserRole.USER]: 1,
        [UserRole.VENUE_ADMIN]: 2,
        [UserRole.SITE_ADMIN]: 3,
        [UserRole.SUPER_ADMIN]: 4,
    };
    return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
}
/**
 * Check if user is an admin (any level)
 */
export function isAdmin(role) {
    return (role === UserRole.VENUE_ADMIN || role === UserRole.SITE_ADMIN || role === UserRole.SUPER_ADMIN);
}
/**
 * Role level mapping constants for admin dashboard access
 */
export const ROLE_LEVELS = {
    [UserRole.ANONYMOUS]: 0,
    [UserRole.USER]: 1,
    [UserRole.VENUE_ADMIN]: 2,
    [UserRole.SITE_ADMIN]: 3,
    [UserRole.SUPER_ADMIN]: 4,
};
/**
 * Check if user has admin dashboard access (SITE_ADMIN or SUPER_ADMIN only)
 * This is different from isAdmin which includes VENUE_ADMIN
 */
export const hasAdminAccess = (role) => {
    if (!role)
        return false;
    return role === UserRole.SITE_ADMIN || role === UserRole.SUPER_ADMIN;
};
/**
 * Check if user role level meets minimum required level
 */
export const meetsRoleLevel = (userRole, minimumRole) => {
    return ROLE_LEVELS[userRole] >= ROLE_LEVELS[minimumRole];
};
export * from './avatar';
export * from './media';
export * from './venue';
export * from './wine';
export * from './mediaLibrary';
export * from './mediaPermissions';
export * from './devAuth';
export * from './validation';
export * from './password';
export * from './relativeTime';
export { formatDistance, haversineMeters, detectDistanceLocale, metersToMiles, metersToKilometers, EARTH_RADIUS_METERS, } from './distance.js';
export * from './searchStateSerializer';
export * from './authError';
